var map = {
	"./add.svg": "76a4",
	"./amusement.svg": "4c479",
	"./beauty.svg": "9617",
	"./bonus.svg": "3032",
	"./book.svg": "fc4e",
	"./calendar.svg": "b8bd",
	"./cashGift.svg": "6853",
	"./chart.svg": "2f02",
	"./child.svg": "6f31",
	"./clothes.svg": "767f",
	"./communication.svg": "ac20",
	"./contribute.svg": "a2d1",
	"./dailyUse.svg": "cf3b",
	"./delivery.svg": "4a78",
	"./digital.svg": "6766",
	"./financing.svg": "13c8",
	"./fruits.svg": "f95d",
	"./gift.svg": "fb5c",
	"./home.svg": "ac9d",
	"./housing.svg": "ec44",
	"./info.svg": "76ed",
	"./laborage.svg": "82d5",
	"./learn.svg": "2d29",
	"./lineChart.svg": "e7e0",
	"./livingExpenses.svg": "4e88",
	"./lottery.svg": "bdc7",
	"./medical.svg": "be1c",
	"./noTally.svg": "fec7",
	"./official.svg": "fa06",
	"./oldMan.svg": "f97a",
	"./other.svg": "4e6e",
	"./partTime.svg": "a655",
	"./pet.svg": "ea5a",
	"./pieChart.svg": "b027",
	"./plus.svg": "eb38",
	"./redEnvelope.svg": "4e24",
	"./reimbursement.svg": "2bfd",
	"./repair.svg": "ab9e",
	"./repast.svg": "2466",
	"./search.svg": "d103",
	"./shopping.svg": "23e8",
	"./smokeWine.svg": "d0fd",
	"./snacks.svg": "fa42",
	"./social.svg": "d05e",
	"./sports.svg": "183a",
	"./statistics.svg": "8ccb",
	"./sub.svg": "3c3f",
	"./toBack.svg": "3b8f",
	"./traffic.svg": "2a2a",
	"./travel.svg": "34dc",
	"./vegetable.svg": "ca25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";